import {setAppInstance} from '~/utils/app-accessor'

export default defineNuxtPlugin(() => {
    setAppInstance(useNuxtApp())
})
